import { Component, input, OnInit } from '@angular/core';
import { MemberModel } from '../../../../core/models/data/member.model';
import { SentEmailListTableComponent } from '../../../sent-email/components/sent-email-list-table/sent-email-list-table.component';
import { SentEmailListViewLocations } from '../../../../core/enums/base.enums';
import { SentEmailFilter } from '../../../../core/filters/sent-email.filter';
import { ListConstants } from '../../../../core/constants/lists.constants';

@Component({
  selector: 'ms-member-communication-history',
  imports: [SentEmailListTableComponent],
  templateUrl: './member-profile-communication-history.component.html'
})
export class MemberProfileCommunicationHistoryComponent implements OnInit {
  public member = input<MemberModel | undefined>(undefined);

  public SentEmailListViewLocations = SentEmailListViewLocations;
  public communicationHistoryFilter: SentEmailFilter = ListConstants.SENT_EMAILS_FILTER_DEFAULT();
  public orderBy: string = ListConstants.SENT_EMAILS_ORDERBY_DEFAULT();

  public ngOnInit(): void {
    const memberId = this.member()?.memberId;
    if (memberId != null) {
      this.communicationHistoryFilter.recipientMemberIds = [memberId];
    }
  }

  public onOrderByChanged(value: string): void {
    this.orderBy = value;
  }
}
